import { trackEvent, eventNameConstants, interactionTypeConstants } from 'dibs-tracking';

const { EVENT_CONTACT_1STDIBS } = eventNameConstants;
const { INTERACTION_TYPE_SIERRA_CHAT } = interactionTypeConstants;

function trackSierraChatEvent({
    step_interaction_name,
    trigger,
    step_type,
}: {
    step_interaction_name: string;
    trigger: string;
    step_type?: string;
}): void {
    trackEvent({
        eventName: EVENT_CONTACT_1STDIBS,
        interaction_type: INTERACTION_TYPE_SIERRA_CHAT,
        step_interaction_name,
        trigger,
        step_type,
    });
}

function trackChatOpened({ placement, topic }: { placement: string; topic?: string }): void {
    trackSierraChatEvent({
        step_interaction_name: 'chat opened',
        trigger: placement,
        step_type: topic,
    });
}

function trackChatClosed({ placement, topic }: { placement: string; topic?: string }): void {
    trackSierraChatEvent({
        step_interaction_name: 'chat closed',
        trigger: placement,
        step_type: topic,
    });
}

function trackConversationStarted({
    placement,
    topic,
}: {
    placement: string;
    topic?: string;
}): void {
    trackSierraChatEvent({
        step_interaction_name: 'conversation started',
        trigger: placement,
        step_type: topic,
    });
}

function trackConversationEnded({ placement, topic }: { placement: string; topic?: string }): void {
    trackSierraChatEvent({
        step_interaction_name: 'conversation ended',
        trigger: placement,
        step_type: topic,
    });
}

function trackUserMessageSent({ placement, topic }: { placement: string; topic?: string }): void {
    trackSierraChatEvent({
        step_interaction_name: 'user message sent',
        trigger: placement,
        step_type: topic,
    });
}

function trackAgentMessageSent({
    type,
    placement,
    topic,
}: {
    type: 'start' | 'end';
    placement: string;
    topic?: string;
}): void {
    trackSierraChatEvent({
        step_interaction_name: `agent message sent - ${type}`,
        trigger: placement,
        step_type: topic,
    });
}

function trackAgentAttachmentSent({
    placement,
    topic,
}: {
    placement: string;
    topic?: string;
}): void {
    trackSierraChatEvent({
        step_interaction_name: 'agentattachment sent',
        trigger: placement,
        step_type: topic,
    });
}

function trackHumanTransferInitiated({
    placement,
    topic,
}: {
    placement: string;
    topic?: string;
}): void {
    trackSierraChatEvent({
        step_interaction_name: 'human transfer initiated',
        trigger: placement,
        step_type: topic,
    });
}

function trackHumanAgentJoin({ placement, topic }: { placement: string; topic?: string }): void {
    trackSierraChatEvent({
        step_interaction_name: 'human agent join',
        trigger: placement,
        step_type: topic,
    });
}

export {
    trackChatOpened,
    trackChatClosed,
    trackConversationStarted,
    trackConversationEnded,
    trackUserMessageSent,
    trackAgentMessageSent,
    trackAgentAttachmentSent,
    trackHumanTransferInitiated,
    trackHumanAgentJoin,
};
